<template>
  <Modal @close="closeModal">
    <template v-slot:title>{{
      t(title, {}, { locale: $store.getters.getLang })
    }}</template>
    <template v-slot:body>
      <form>
        <div class="form-group row my-1">
          <ModalInput
            v-if="!bpId"
            v-model="bPlace.name"
            v-bind:placeholder="'Enter Name'"
            v-bind:label="'Name'"
            v-bind:id="'name'"
            v-bind:type="'text'"
          >
            <template v-slot:error>
              <ModalError v-if="errors.name" v-bind:error="errors.name" />
            </template>
          </ModalInput>
          <ModalInput
            v-else
            v-model="bPlace.newName"
            v-bind:placeholder="'Enter Name'"
            v-bind:label="'Name'"
            v-bind:id="'name'"
            v-bind:type="'text'"
          >
            <template v-slot:error>
              <ModalError v-if="errors.name" v-bind:error="errors.name" />
            </template>
          </ModalInput>
        </div>
        <div class="form-group row my-1">
          <ModalCheckCheck
            v-model="bPlace.default"
            v-bind:label="'Default Boarding'"
            v-bind:id="'default-boarding'"
          >
            <!-- <template v-slot:error>
              <Error
                v-if="errors.deckAvailability"
                v-bind:error="errors.deckAvailability"
              />
            </template> -->
          </ModalCheckCheck>
        </div>

        <div class="form-group row my-1">
          <label class="col-sm-3 col-form-label"></label>
          <div class="col-sm-9">
            <!-- <input
              v-if="!bpId"
              type="submit"
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="addBoardingPlace"
            />
            <input
              v-else
              type="submit"
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="updateBoardingPlace"
            /> -->
            <button
              v-if="!bpId"
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="addBoardingPlace"
            >
              {{ t("Submit", {}, { locale: $store.getters.getLang }) }}
            </button>
            <button
              v-else
              class="mt-3 py-2 submit_button font_detail float-end"
              @click.prevent="updateBoardingPlace"
            >
              {{ t("Submit", {}, { locale: $store.getters.getLang }) }}
            </button>
          </div>
        </div>
      </form>
    </template>
  </Modal>
</template>

<script>
import dropdownVariables from "@/modules/dropdownVariables";
import useInputValidation from "@/modules/useInputValidations";
import { inject, onBeforeMount, ref, watch } from "vue";
import { reactive } from "@vue/reactivity";

import store from "../../../../../../store";
import { useI18n } from "vue-i18n";
export default {
  name: "BoardingPlaceAddUpdateModal",
  props: {
    boardingPlace: String,
    stoppage: String,
    boardingPlaceName: String,
    defaultBoarding: Boolean,
  },
  setup(props, { emit }) {
    let { requiredValidation, errors } = useInputValidation();
    let bPlace = reactive({
      stoppageId: "",
      name: "",
      previousName: "",
      newName: "",
      default: false,
    });
    const bpId = ref(props.boardingPlace);
    const sId = ref(props.stoppage);
    const bpName = ref(props.boardingPlaceName);
    const defaultBoardingProp = ref(props.defaultBoarding);

    const status = dropdownVariables.status;
    const title = ref("Add Boarding Place");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const { t, locale } = useI18n();
    watch(
      () => bPlace.name,
      () => {
        requiredValidation("name", bPlace.name);
      }
    );
    watch(
      () => bPlace.newName,
      () => {
        requiredValidation("name", bPlace.newName);
      }
    );

    const validate = () => {
      Object.keys(errors).forEach(function (key) {
        errors[key] = "";
      });
      if (!bpId.value) {
        requiredValidation("name", bPlace.name);
      } else {
        requiredValidation("name", bPlace.newName);
      }
      return !(
        Object.values(errors).length <= 0 ||
        !Object.values(errors).every((x) => x === null || x === "")
      );
    };
    const closeModal = () => {
      emit("update:modelValue", false);
    };
    const addBoardingPlace = () => {
      if (validate()) {
        showLoader();
        store
          .dispatch("addOwnerServicesBoardingPlaceForStoppage", bPlace)
          .then(() => {
            hideLoader();
            emit("getAllBoardingPlaces");
            closeModal();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              addBoardingPlace();
            }
          });
      }
    };
    const updateBoardingPlace = () => {
      if (validate()) {
        showLoader();
        // bPlace.newName = bPlace.name;

        store
          .dispatch("updateOwnerServicesBoardingPlaceForStoppage", bPlace)
          .then(() => {
            hideLoader();
            emit("getAllBoardingPlaces");
            closeModal();
          })
          .catch((error) => {
            hideLoader();
            if (error.status === 401) {
              updateBoardingPlace();
            }
          });
      }
    };

    onBeforeMount(() => {
      Object.keys(errors).forEach(function (key) {
        delete errors[key];
      });

      bPlace.stoppageId = sId.value;

      if (bpId.value !== "") {
        title.value = "Update Boarding Place";
        bPlace.previousName = bpName.value;
        bPlace.newName = bpName.value;
        bPlace.default = defaultBoardingProp;
      }
    });

    return {
      t,
      locale,
      bpId,
      bPlace,
      errors,
      status,
      title,
      addBoardingPlace,
      updateBoardingPlace,
      closeModal,
    };
  },
};
</script>

<style scoped></style>
